import {ResponseXBVO} from "../base/base.model";
import { EnumMenuLineType, MealTypeEnum, SaldoChangeEnumType } from "./dto.models.imported";

/**
 * Model - BsaMenuDetailsXBVO
 */
export class BsaMenuDetailsXBVO extends ResponseXBVO {
    menu: MpMenuXBVO;
}


/**
 * Model - BsaMenuDetailsXBVO
 */
export class MpMenuXBVO {
    imageUrl: string;
    menuDate: Date;
    menuID: string;
    menuLine: EnumMenuLineType;
    menuLineDesignation: string;
    menuName: string;
    nutritions: MpNutritionsXBVO;
    additive: MpAdditiveXBVO[] = [];
    allergen: MpAllergenXBVO[] = [];
    component: MpComponentXBVO[] = [];
    confirmation: MpConfirmationXBVO[] = [];
}

/**
 * Model - MpNutritionsXBVO
 */
export class MpNutritionsXBVO {
    carbohydrate: number;
    energy: number;
    energyKCal: number;
    fat: number;
    protein: number;
    saturatedFattyAcids: number;
    sodium: number;
    sugar: number;
}

/**
 * Model - MpDesignationXBVO
 */
export class MpDesignationXBVO {
    designation: string;
    lang: string;
    nr: string;
}


/**
 * Model - MpAdditiveXBVO
 */
export class MpAdditiveXBVO extends MpDesignationXBVO {
}


/**
 * Model - MpAllergenXBVO
 */
export class MpAllergenXBVO extends MpDesignationXBVO {
}


/**
 * Model - MpAllergenXBVO
 */
export class MpConfirmationXBVO extends MpDesignationXBVO {
}


/**
 * Model - MpComponentXBVO
 */
export class MpComponentXBVO {
    additive: MpAdditiveXBVO[] = [];
    allergen: MpAllergenXBVO [] = [];
    designation: string;
    nutritions: MpNutritionsXBVO;
    imageUrl: string;
    userDefined: boolean;
}

/**
 * Model - BsaOrderHistoryXBVO
 */
export class BsaOrderHistoryXBVO extends ResponseXBVO {
    order: OrderXBVO[] = [];
}

/**
 * Model - OrderXBVO
 */
export class OrderXBVO {
    mealType: MealTypeEnum;
    menuLine: EnumMenuLineType;
    menuLineDesignation: string;
    menuName: string;
    placingType: EnumOrderPlacingType;
    serviceDay: Date;
}


/**
 * Model - BsaIncomingMessagesXBVO
 */
export class BsaIncomingMessagesXBVO {
    incomingMessage: IncomingMessageXBVO[] = [];
}


/**
 * Model - IncomingMessageXBVO
 */
export class IncomingMessageXBVO {
    body: string;
    created: Date;
    createdBySupport: boolean;
    id: number;
    deliveryId: number;
    readed: Date;
    subject: string;
}


/**
 * Model - BsaMenuPlanLinksXBVO
 */
export class BsaInvoiceLinksXBVO extends ResponseXBVO {
    link: InvoiceLinkXBVO[] = [];
}

/**
 * Model - BsaMenuPlanLinksXBVO
 */
export class InvoiceLinkXBVO {
    invoiceNr: string;
    invoiceDate: Date;
}

/**
 * Model - BsaMenuPlanLinksXBVO
 */
export class BsaMenuPlanLinksXBVO extends ResponseXBVO {
    link: MenuPlanLinkXBVO[] = [];
}

/**
 * Model - BsaMenuPlanLinksXBVO
 */
export class MenuPlanLinkXBVO {
    dietName: string;
    fileDate: Date;
    fileName: string;
    week: number;
    year: number;
}

/**
 * Model - BsaMenuDetailsXBVO
 */
export class BsaProfileInfoXBVO extends ResponseXBVO {
    cafeteria: boolean;
    cafeteriaFrom: Date;
    cafeteriaLockFrom: Date;
    cafeteriaLockInfo: string;
    cpAddr: AddressXBVO;
    cpName: string;
    cpNr: string;
    creditorTaxNr: string;
    faExternalObjectNr: string;
    faObjectName: string;
    faObjectNr: string;
    grMark: string;
    grName: string;
    notifyPlanChangedActive: boolean;
    notifyPlanChangedLast: Date;
    orderDisabled: Boolean;
    orderDisabledReason: string;
    prepaid: Boolean;
    prepaidAutoChargeEnabled: Boolean;
    prepaidSaldo: number;
    prepaidSaldoDate: Date;
    prepaidState: string;
    prepaidVSaldo: number
    prepaidWarnDate: Date;
    rfidBarcode: string;
    rfidCreated: Date;
    rfidNNr: number;
    rfidNr: string;
    rfidSeries: string;
    sepaAccountOwner: string;
    sepaAccountOwnerAddr: string;
    sepaEnabled: boolean;
    sepaActive: boolean;
    sepaChanged?: boolean;
    sepaBIC: string;
    sepaIBAN: string;
    sepaIBANCountry: string;
    sepaInstitut: string;
    standingOrdersInfo: string;
    terminationDate: Date;
    terminationRequestDate: Date;
    terminationState: string;
    tgAddr: AddressXBVO
    tgBirthday: Date;
    tgContractEnd: Date;
    tgContractStart: Date;
    tgGender: string;
    tgName: string;
}

export class PasswordChangeXBVO {
    oldPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
}


/**
 * Model - BsaMenuDetailsXBVO
 */
export class AddressXBVO {
    city: string;
    country: string;
    email: string;
    phoneArea: string;
    phoneMobile: string;
    phoneNr: string;
    state: string;
    streetName: string;
    streetNr: string;
    territoryNr: string;
    zip: string;
}

/**
 * Model - BsaPrepaidAutoChargeXBVO
 */
export class BsaPrepaidAutoChargeXBVO {
    autoChargeAmount : number;
    chargePrerequisites : ChargePrerequisites;
    currentVSaldo : number;
    autochargeThreshold : number;
    saldoChange : SaldoChangeXBVO[];
}

/**
 * Model - ChargePrerequisites
 */
export class ChargePrerequisites {
    changeSettingsEnabled : boolean;
    chargeEnabled : boolean;
    chargeNotRunning : boolean;
    cpIbanValid : boolean;
    cpSepaActive : boolean;
    faAutoChargeEnabled : boolean;
    tgOrderNotBlocked : boolean;
    contractValid : boolean;
}

/**
 * Model - SaldoChangeXBVO
 */
export class SaldoChangeXBVO {
    changeAmount : number;
    changeDate : Date;
    changeType : SaldoChangeEnumType;
    currentVSaldo : number;
}

/**
 * Model - SaldoDetailsXBVO
 */
export class SaldoDetailsXBVO {
    tableguestPrepaidActive: boolean;
    firstDayOfMonth: Date;
    monthStartSaldo: number;
    amountRecharges: number;
    amountOrdersClosed: number;
    amountOrdersFuture: number;
    numberOrdersFuture: number;
}

/**
 * Enum - EnumOrderPlacingType
 */
export enum EnumOrderPlacingType {
    CLIENT = 'CLIENT',
    STANDING_ORDER = 'STANDING_ORDER',
    IMPORT_SERVICE = 'IMPORT_SERVICE',
    CUSTOMER_SERVICE = 'CUSTOMER_SERVICE'
}

